<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div style="overflow-x: hidden;overflow-y: auto; width: 100%;height:90%;margin-top: 2%;display: flex;justify-content: center; "
       v-loading="loding">
    <div style="width: 90%;">
      <div style="margin-top: 2%;">会展主题：{{ DataAnalysis.exhibitionTheme }}</div>
      <div>会展时间：{{ (DataAnalysis.starData||'').split('T')[0] }}至{{ (DataAnalysis.endData||'').split('T')[0] }}</div>
      <div>总结部门：数据分析</div>
      <div>总结内容：本次展会市场趋势情况:<span class="span">{{DataAnalysis.marketReport}}</span>
        <label v-if="DataAnalysis.purchaseEnterpriseType==''">未购买行业的营销数据，</label>
        <label v-if="DataAnalysis.purchaseEnterpriseType!=''"> 购买了<span class="span">{{DataAnalysis.purchaseEnterpriseType}}</span>行业的营销数据，</label>
        在过程分析中观察到共有<span class="span">{{DataAnalysis.signIn}}</span>条
        签到数据，其中有<span class="span">{{DataAnalysis.exhibitor}}</span>家参展商进行了签到，
        <span class="span"> {{DataAnalysis.expert}}</span>位专家/领导进行了签到，安排了
        <span class="span">{{DataAnalysis.stay}}</span> 位专家/领导入住了酒店。共有<span class="span">{{DataAnalysis.audience}}</span>位参展观众,<span class="span">{{ DataAnalysis.exhibitors }}</span>家参展企业。
      </div>
      <div>
        通过反馈数据查看出参展人员共<span class="span">{{DataAnalysis.personnelSatisfaction}}</span>位对本次展会满意，
        <span class="span">{{DataAnalysis.personnelZhongke}}</span>位对本次展会保持中肯，
        <span class="span">{{DataAnalysis.personnelDissatisfaction}}</span>位对本次展会感觉不满意。
        参展商共<span class="span">{{DataAnalysis.exhibitorSatisfaction}}</span>位对本次展会满意，
        <span class="span">{{DataAnalysis.exhibitorZhongke}}</span>位对本次展会保持中肯，
        <span class="span">{{DataAnalysis.exhibitorDissatisfied}}</span>位对本次展会感觉不满意。
        若再次举办类似展会有
        <span class="span">{{DataAnalysis.personnelWilling}}</span>位愿意参加，
        <span class="span">{{DataAnalysis.personnelConsider}}</span>位有待考虑是否参加，
        <span class="span">{{DataAnalysis.personnelReluctant}}</span>位不愿意再次参加。
      </div>
      <div class="drawerDiv">
        <div id="chartSG"
            v-if="true"></div>
      </div>
    </div>
  </div>
</ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {
    ShowControl
  },
  data () {
    return {
      caseID: localStorage.getItem("caseId"),
      DataAnalysis: {},
      DataAnalysiss: {},
      loding: false,
      checkSummarize: 0,
      flowID: localStorage.getItem("flowID"),
      title: '会展数据总结'
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  mounted () {
    this.drawSg();
    this.$refs.showControl.receiveValue(true);
  },
  created () {
    //this.GetDataAnalysis();
  },
  methods: {
    revertClick(){
      this.$router.push("/DataAnalysis")
    },
    drawSg () {
      this.loding = true;
      this.$nextTick((_) => {
        console.log(_)
        var chartDom = document.getElementById('chartSG');
        var myChart = this.echarts.init(chartDom);
        var option;
        this.$http
          .get(`Summarize/GetDataAnalysis?round=${this.Round}&CaseID=${this.caseID}`)
          .then((res) => {
            if (res.success) {
              this.DataAnalysiss = res.dynamicObj;
              this.DataAnalysis = res.dynamicObj.result;
              option = {
                backgroundColor: '#fff',
                series: [
                  {
                    type: 'sankey',
                    data: this.DataAnalysiss.data,
                    links: this.DataAnalysiss.link,
                    emphasis: {
                      focus: 'adjacency'
                    },
                    lineStyle: {
                      color: 'gradient',
                      curveness: 0.5
                    }
                  }
                ],
                tooltip: {
                  trigger: 'item',
                  triggerOn: 'mousemove'
                }
              };
              option && myChart.setOption(option);
              if (this.flowID == this.Global.FlowList.实验总结) {
                let that = this;
                let checkSummarize = that.$store.state.user.checkSummarize;
                if ((that.$store.state.user.checkSummarize & (1 << 2)) == 0) {
                  checkSummarize += 4;
                  this.checkSummarize = checkSummarize;
                  that.$store.commit("checkSummarizecomit", checkSummarize);
                }
              }
              this.loding = false;
              if(this.flowID == 5){
                this.$http
                .get(`StudentData/GetStepOperation?stepID=${this.Global.OperateType.查看数据分析总结}&round=${this.Round}`)
                .then((res) => {
                  if (res.success) {
                    this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看数据分析总结 });  
                  }
                }) 
              }
            } else {
              return this.$message.error(res.message);
            }
          });
      })
    },
    GetDataAnalysis () {
      this.$http.get(`Summarize/GetDataAnalysis?round=${this.Round}&CaseID=${this.caseID}`).then((res) => {
        if (res.success) {
          this.DataAnalysis = res.dynamicObj
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  watch: {
    checkSummarize (newVal, oldVal) {
      if (newVal == 31) {
        if (this.flowID == this.Global.FlowList.实验总结) {
          this.$http.get(`User/SummarizeScore?round=${this.Round}`).then((res) => {
            if (res.success) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              checkSummarize += 1;
              this.checkSummarize = checkSummarize;
              that.$store.commit("checkSummarizecomit", checkSummarize);
            }
          })
        }
      } else {
        console.log(oldVal)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.span {
  color: red;
}
.drawerDiv {
  height: 100%;
  display: flex;
  justify-content: center;
}
#chartSG {
  width: 825px;
  height: 580px;
  color: white;
}
</style>